"use client";

import React from "react";

import { ArrowLeftIcon } from "@/components/icons-lib";

interface DetailsPanelBackButtonProps {
  onClick: () => void;
  label: string;
}

const DetailsPanelBackButtonComponent: React.FC<DetailsPanelBackButtonProps> = ({
  onClick,
  label,
}) => {
  return (
    <button
      className="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-50"
      type="button"
      onClick={onClick}
    >
      <ArrowLeftIcon className="h-5 w-5 shrink-0" />
      {label}
    </button>
  );
};

export const DetailsPanelBackButton = React.memo(DetailsPanelBackButtonComponent);
